import community from '../../assets/Community.png'
const Community = () => {
  return (
    <div className='py-16'>
      <img className='w-full object-cover' src={community} alt="" />
    </div>
  )
}
export default Community